import ProfileForm from './profile-form/profile-form'
import ProfileInput from './profile-input/profile-input'
import ProfileFieldValue from './profile-field-value/profile-field-value'
import AcceptSwitcher from './accept-switcher/accept-switcher'
// Profile inputs
import ProfileNameInput from './profile-inputs/profile-name-input'
import ProfileAcceptInput from './profile-inputs/profile-accept-input'
import ProfilePhoneInput from './profile-inputs/profile-phone-input'
import ProfileAddressInput from './profile-inputs/profile-address-input'
import ProfileGenderInput from './profile-inputs/profile-gender-input'
import ProfileBirthdayInput from './profile-inputs/profile-birthday-input'
import ProfileWaterPreferenceInput from './profile-inputs/profile-water-preference-input'
import ProfileTreatPreferenceInput from './profile-inputs/profile-treat-preference-input'
import ProfileInterestsInput from './profile-inputs/profile-interests-input'
import ProfileCommunicationInterestsInput from './profile-inputs/profile-communication-interests-input'
import ProfileDestinationsInput from './profile-inputs/profile-destinations-input/profile-destinations-input'
import DestinationValueItem from './profile-inputs/profile-destinations-input/components/destination-value-item.vue'
import ProfileLanguageInput from './profile-inputs/profile-language-input/profile-language-input'
import ProfileLocalMoInput from './profile-inputs/profile-local-mo-input/profile-local-mo-input'
import ProfileSustainabilityPreferenceInput from './profile-inputs/profile-sustainability-preference-input.vue'

export {
  ProfileForm,
  ProfileInput,
  ProfileFieldValue,
  AcceptSwitcher,
  // Profile inputs export
  ProfileNameInput,
  ProfileAcceptInput,
  ProfilePhoneInput,
  ProfileBirthdayInput,
  ProfileWaterPreferenceInput,
  ProfileTreatPreferenceInput,
  ProfileAddressInput,
  ProfileGenderInput,
  ProfileInterestsInput,
  ProfileCommunicationInterestsInput,
  ProfileDestinationsInput,
  DestinationValueItem,
  ProfileLanguageInput,
  ProfileLocalMoInput,
  ProfileSustainabilityPreferenceInput
}
